import { createFileRoute, Outlet } from "@tanstack/react-router";

import { isProjectTypeMember } from "@/core/lib/access";
import { FAS_PROJECT_TYPE } from "@/core/lib/constants";
import { denyRouteAccess } from "@/core/lib/route-access";

// no fabric gate: a FAS project reads nothing from the warehouse yet
export const Route = createFileRoute("/_protected/fas")({
  beforeLoad: ({ context, ...guard }) => {
    if (!isProjectTypeMember(context.user, FAS_PROJECT_TYPE)) {
      denyRouteAccess(guard, "fas_membership");
    }
  },
  component: Outlet,
});
